// Translation: Model > Access key manager > Access key managing dialog > Access key information form (Turkish)
export default Object.freeze({
	actions: {
		limit: 'Süre sınırı ekle'
	},
	fields: {
		expirationDate: {
			label: 'Son geçerlilik tarihi',
			helper: {
				default: 'Son geçerlilik saati {{time}} (kendi saat diliminiz)',
				invalidDate: 'Geçersiz tarih',
				outOfRange: 'Hedef aralık dışında'
			}
		},
		name: {
			helper: 'İsim zaten kullanımda',
			label: 'İsim',
			placeholder: 'Erişim anahtarı ismini girin'
		},
		type: {
			helper: 'Yönetici anahtarları SDK üzerinden hız ve kullanım limitlerini ayarlar, ancak sonuç almak için kullanılamaz.',
			label: 'Yönetici anahtarı'
		}
	}
})
